/* eslint-disable no-console */
import {DevToolsListener} from './DevToolsListener';
import {isMobile, isTablet} from './PlatformUtils';
import i18n from '../i18n';

interface TokenManager {
  hideToken: () => void;
  showToken: () => void;
}

interface RemoteApp {
  getVersion: () => string;
}

interface DiscordNativeWindow {
  setDevtoolsCallbacks: (onOpened: () => void, onClosed: () => void) => void;
  webContents: {
    removeAllListeners: (event: string) => void;
    on: (event: string, cb: () => void) => void;
  };
}

function consoleWarning(count = 0) {
  // i18n may not have loaded yet.
  if (i18n.Messages.SELF_XSS_HEADER != null) {
    console.log(
      `%c${i18n.Messages.SELF_XSS_HEADER}`,
      'color: #5865f2; -webkit-text-stroke: 2px black; font-size: 72px; font-weight: bold;',
    );
    console.log(`%c${i18n.Messages.SELF_XSS_LINE_1}`, 'font-size: 16px;');
    console.log(`%c${i18n.Messages.SELF_XSS_LINE_2}`, 'font-size: 18px; font-weight: bold; color: red;');
    if (count >= 4) {
      console.log(`%c${i18n.Messages.SELF_XSS_LINE_3}`, 'font-size: 16px;');
      const jobsLine = i18n.Messages.SELF_XSS_LINE_4
        // @ts-expect-error awaiting i18n type generation for discord_common
        .format({
          url: `${location.protocol}${window.GLOBAL_ENV.MARKETING_ENDPOINT}/jobs`,
        });
      console.log(`%c${jobsLine}`, 'font-size: 16px;');
    } else {
      setTimeout(() => consoleWarning(count + 1), 1000);
    }
  }
}
export function UserDefenses(
  tokenManager: TokenManager,
  DiscordNative?: {
    window: DiscordNativeWindow;
    remoteApp: RemoteApp;
  },
) {
  if (process.env.NODE_ENV !== 'production') return;
  if (DiscordNative != null && DiscordNative.remoteApp.getVersion() === '0.0.0') return;
  const listener = new DevToolsListener();

  if (DiscordNative != null) {
    if (DiscordNative.window.setDevtoolsCallbacks != null) {
      DiscordNative.window.setDevtoolsCallbacks(
        () => {
          tokenManager.hideToken();
          consoleWarning();
        },
        () => {
          tokenManager.showToken();
        },
      );
    } else {
      const webContents = DiscordNative.window.webContents;
      webContents.removeAllListeners('devtools-opened');
      webContents.on('devtools-opened', () => {
        tokenManager.hideToken();
        consoleWarning();
      });
      webContents.on('devtools-closed', tokenManager.showToken);
    }
  } else if (!isMobile && !isTablet) {
    listener.on('changed', ({open}: {open: boolean}) => {
      if (open) {
        tokenManager.hideToken();
        consoleWarning();
      } else {
        tokenManager.showToken();
      }
    });
  }
  window.addEventListener('beforeunload', (e) => {
    if (!e.isTrusted) return;
    tokenManager.showToken();
  });
}
